import React, { useEffect, useState } from 'react'
import { Label, Text } from '@workwhile/ui'
import { JetCallReportItem } from 'api/admin/jet/listJetCallReports'

const TICK_MS = 60 * 1000

const formatRemaining = (ms: number) => {
  const totalHours = Math.floor(ms / (60 * 60 * 1000))
  const days = Math.floor(totalHours / 24)
  const hours = totalHours % 24
  if (days > 0) {
    return `${days}d ${hours}h left`
  }
  return `${hours}h left`
}

export const JetReportDeadlineCell = ({
  item,
}: {
  item: JetCallReportItem
}) => {
  // Re-tick so the countdown stays live between data refetches.
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), TICK_MS)
    return () => clearInterval(interval)
  }, [])

  if (item.status !== 'pending') {
    // Only `pending` has a running deadline.
    return <Text color="lightText">-</Text>
  }

  // Clamp: a `pending` row is never past its deadline.
  const remainingMs = Math.max(
    0,
    new Date(item.reportDeadlineAt).getTime() - now
  )
  const isAlerted = item.lastAlertedAt !== null

  return (
    <Label
      variant={isAlerted ? 'warning' : 'neutral'}
      size="small"
      style={{ whiteSpace: 'nowrap' }}
    >
      {isAlerted
        ? `Stuck · ${formatRemaining(remainingMs)}`
        : formatRemaining(remainingMs)}
    </Label>
  )
}
